import { put, takeLatest } from "redux-saga/effects";
import { animalsActions } from "src/store/animals/animals.actions";
import { backendUrl } from "src/config";
import axiosInstance from "src/axios-instance";

function* getAnimals() {
  try {
    const animals = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/animals`,
      withCredentials: true
    });
    yield put(animalsActions.fetchSuccess({ animals: animals.data.animals }));

    /*
    yield put(
      animalsActions.fetchSuccess({
        animals: {
          cattle: [
            {
              mark_no: '17563187',
              individual_no: '0027',
              subcategory_name: 'ku',
              birthdate: '2014-05-04',
            },
            {
              mark_no: '17563187',
              individual_no: '0028',
              subcategory_name: 'ku',
              birthdate: '2014-05-09',
            },
            {
              mark_no: '17563187',
              individual_no: '0031',
              subcategory_name: 'ku',
              birthdate: '2014-05-19',
            },
            {
              mark_no: '17563187',
              individual_no: '0032',
              subcategory_name: 'ku',
              birthdate: '2014-06-08',
            },
            {
              mark_no: '17193316',
              individual_no: '0816',
              subcategory_name: 'ku',
              birthdate: '2016-04-20',
            },
            {
              mark_no: '17193316',
              individual_no: '0819',
              subcategory_name: 'ku',
              birthdate: '2016-04-24',
            },
            {
              mark_no: '17193316',
              individual_no: '0820',
              subcategory_name: 'ku',
              birthdate: '2016-05-10',
            },
            {
              mark_no: '17193316',
              individual_no: '0821',
              subcategory_name: 'ku',
              birthdate: '2017-03-16',
            },
            {
              mark_no: '17193316',
              individual_no: '0826',
              subcategory_name: 'ku',
              birthdate: '2017-03-18',
            },
            {
              mark_no: '17193316',
              individual_no: '0831',
              subcategory_name: 'ku',
              birthdate: '2017-06-15',
            },
            {
              mark_no: '50370606',
              individual_no: '0838',
              subcategory_name: 'ung ku',
              birthdate: '2018-01-27',
            },
            {
              mark_no: '50370606',
              individual_no: '0845',
              subcategory_name: 'ung ku',
              birthdate: '2018-03-18',
            },
            {
              mark_no: '50370606',
              individual_no: '0856',
              subcategory_name: 'ung ku',
              birthdate: '2019-01-30',
            },
            {
              mark_no: '50370606',
              individual_no: '0872',
              subcategory_name: 'kvige',
              birthdate: '2019-12-29',
            },
            {
              mark_no: '50370606',
              individual_no: '0875',
              subcategory_name: 'kvige',
              birthdate: '2019-12-31',
            },
            {
              mark_no: '2502012',
              individual_no: '00883',
              subcategory_name: 'ung okse',
              birthdate: '2020-01-24',
            },
            {
              mark_no: '2502012',
              individual_no: '00884',
              subcategory_name: 'ung okse',
              birthdate: '2020-01-25',
            },
            {
              mark_no: '2502012',
              individual_no: '00885',
              subcategory_name: 'kvige',
              birthdate: '2020-01-29',
            },
            {
              mark_no: '2502012',
              individual_no: '00886',
              subcategory_name: 'ung okse',
              birthdate: '2020-01-29',
            },
            {
              mark_no: '2502012',
              individual_no: '00887',
              subcategory_name: 'kvige',
              birthdate: '2020-01-29',
            },
            {
              mark_no: '2502012',
              individual_no: '00888',
              subcategory_name: 'ung okse',
              birthdate: '2020-01-29',
            },
            {
              mark_no: '2502012',
              individual_no: '00889',
              subcategory_name: 'kvige',
              birthdate: '2020-02-01',
            },
            {
              mark_no: '2502012',
              individual_no: '00890',
              subcategory_name: 'kvige',
              birthdate: '2020-02-05',
            },
            {
              mark_no: '2502012',
              individual_no: '00891',
              subcategory_name: 'kvige',
              birthdate: '2020-02-22',
            },
            {
              mark_no: '2502012',
              individual_no: '00892',
              subcategory_name: 'ung okse',
              birthdate: '2020-02-23',
            },
            {
              mark_no: '2502012',
              individual_no: '00893',
              subcategory_name: 'ung okse',
              birthdate: '2020-02-23',
            },
            {
              mark_no: '2502012',
              individual_no: '00894',
              subcategory_name: 'kvige',
              birthdate: '2020-02-29',
            },
            {
              mark_no: '2502012',
              individual_no: '00895',
              subcategory_name: 'kvige',
              birthdate: '2020-03-29',
            },
            {
              mark_no: '2502012',
              individual_no: '00896',
              subcategory_name: 'kvige',
              birthdate: '2020-03-01',
            },
            {
              mark_no: '2502012',
              individual_no: '00897',
              subcategory_name: 'ung okse',
              birthdate: '2020-03-02',
            },
            {
              mark_no: '2502012',
              individual_no: '00898',
              subcategory_name: 'kvige',
              birthdate: '2020-05-16',
            },
            {
              mark_no: '2502012',
              individual_no: '00899',
              subcategory_name: 'kvige',
              birthdate: '2020-07-06',
            },
            {
              mark_no: '2502012',
              individual_no: '00901',
              subcategory_name: 'kalv',
              birthdate: '2021-01-31',
            },
            {
              mark_no: '2502012',
              individual_no: '00902',
              subcategory_name: 'kvige',
              birthdate: '2021-01-01',
            },
            {
              mark_no: '2502012',
              individual_no: '00903',
              subcategory_name: 'kvige',
              birthdate: '2021-01-01',
            },
            {
              mark_no: '2502012',
              individual_no: '00904',
              subcategory_name: 'kvige',
              birthdate: '2021-01-02',
            },
            {
              mark_no: '2502012',
              individual_no: '00905',
              subcategory_name: 'kvige',
              birthdate: '2021-01-02',
            },
            {
              mark_no: '2502012',
              individual_no: '00906',
              subcategory_name: 'ung okse',
              birthdate: '2021-01-03',
            },
            {
              mark_no: '2502012',
              individual_no: '00907',
              subcategory_name: 'kvige',
              birthdate: '2021-01-03',
            },
            {
              mark_no: '2502012',
              individual_no: '00908',
              subcategory_name: 'kvige',
              birthdate: '2021-01-04',
            },
            {
              mark_no: '2502012',
              individual_no: '00909',
              subcategory_name: 'kvige',
              birthdate: '2021-01-05',
            },
            {
              mark_no: '2502012',
              individual_no: '00910',
              subcategory_name: 'kalv',
              birthdate: '2021-01-06',
            },
            {
              mark_no: '2502012',
              individual_no: '00911',
              subcategory_name: 'kalv',
              birthdate: '2021-01-06',
            },
            {
              mark_no: '2502012',
              individual_no: '00912',
              subcategory_name: 'kalv',
              birthdate: '2021-02-12',
            },
            {
              mark_no: '2502012',
              individual_no: '00914',
              subcategory_name: 'kalv',
              birthdate: '2021-02-24',
            },
            {
              mark_no: '2502012',
              individual_no: '00915',
              subcategory_name: 'kalv',
              birthdate: '2021-07-20',
            },
            {
              mark_no: '17360260',
              individual_no: '1042',
              subcategory_name: 'okse',
              birthdate: '2016-03-13',
            },
            {
              mark_no: '17193292',
              individual_no: '2037',
              subcategory_name: 'ku',
              birthdate: '2015-04-23',
            },
            {
              mark_no: '17193292',
              individual_no: '2038',
              subcategory_name: 'ku',
              birthdate: '2015-04-24',
            },
          ],
        },
      }),
    ); */
  } catch (error) {
    yield put(animalsActions.fetchFailure({ errorcodes: [] }));
  }
}

function* getAnimalKeeping(action) {
  try {
    let url = `${backendUrl}/api/animal_keeping`;
    if (action.payload.slaughterPage) {
      url += "?slaughter_page=true";
    }
    const animalKeepingResp = yield axiosInstance.request({
      method: "GET",
      withCredentials: true,
      url
    });

    yield put(
      animalsActions.fetchAnimalKeepingSuccess({
        animalKeeping: animalKeepingResp.data.animal_keeping
      })
    );

    /*
    yield put(
      animalsActions.fetchAnimalKeepingSuccess({
        animalKeeping: {
          cattle: true,
          sheep: false,
          pigs: true,
          restrictions: {
            cattle: false,
            sheep: false,
            pigs: false,
          },
          ksl_status: 'green',
          brsv_bcov_ok: false,
          helsegris_ok: true,
        },
      }),
    ); */
  } catch (error) {
    yield put(animalsActions.fetchAnimalKeepingFailure({ errorcodes: [] }));
  }
}

export default [
  takeLatest(animalsActions.fetch().type, getAnimals),
  takeLatest(animalsActions.fetchAnimalKeeping().type, getAnimalKeeping)
];
